// removed by extract-text-webpack-plugin
module.exports = {"Input":"s67N0w35nKdhFxX_3zncw","Label":"_n-1my-7YxR9EuzWR3hhB","InputElement":"_2-aFxd6_SUnHTHpTf8dvYS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.css
// module id = 180
// module chunks = 0